module.exports = __webpack_public_path__ + "img/logo-blanco-puro.d9a73207.png";